/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import Autocomplete from 'react-autocomplete';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledItemWrapper = styled.a`
  font-size: 14px;
  color: #000;
  padding: 0.625rem 0.9375rem 0.625rem 0.5rem;
  font-family: Verizon-NHG-eTX, Helvetica, Arial, sans-serif;
  display: block;
  text-decoration: none;
  .item-highlighted {
    border-left-color: #CD040B;
    background-color: #F6F6F6;
  }
  :hover {
    color: #000;
  }
`;

const MenuItem = styled.div`
  background-color: #fff;
  .item-highlighted {
    background-color: #6092ed;
    border-radius: 4px;
  }
`;

class AutoComplete extends React.PureComponent {
  componentDidMount() {
    const autocompleteInput = document.querySelector('.autocompleteInput');
    if (autocompleteInput) {
      autocompleteInput.onkeydown = (e) => {
        this.onHandleKeydown(e);
      };
    }
  }

  onHandleKeydown = (e) => {
    if (e.keyCode === 38 || e.keyCode === 40) {
      setTimeout(() => {
        const highlightedItem = document.getElementById('selectedOption');
        const itemValue = highlightedItem && (highlightedItem.querySelector('a').innerText || undefined);
        const addressSelected = this.props?.items?.filter((item) => item.disprawstr === itemValue);
        if (itemValue) {
          // debugger;
          if (addressSelected.length === 0) {
            const [addressSelectedNew] = itemValue.split(',');
            e.target.value = addressSelectedNew;
          } else {
            e.target.value = addressSelected?.[0]?.dispstr;
          }
        }
      });
    }
  };

  getItemValue = (item) => {
    const inputval = this?.props?.inputProps?.itemval;
    return item ? item[inputval] : '';
  };

  getHighlightedString = (displayValue) => <>{displayValue}</>;

  renderItem = (item, isHighlighted) => {
    const { typedValue } = this.props;
    if (!typedValue) {
      return <div />;
    }
    const inputval = this.props.inputProps.itemval;
    const inputkey = this.props.inputProps.itemkey.reduce((accumulator, currentItem, index) => {
      if (index === 1) {
        return `${item[accumulator]} - ${item[currentItem]}`;
      }
      return `${accumulator} - ${item[currentItem]}`;
    });

    const displayValue = item[inputval];
    const matchingString = displayValue && displayValue.indexOf(typedValue) > -1 ? typedValue : '';
    const highlightedText = this.getHighlightedString(displayValue, matchingString);
    const dataTrack = this.props.inputProps.datatracker;
    return (
      <MenuItem
        key={inputkey}
        className={`menu-list-item ${isHighlighted ? 'menuHighlighted' : ''}`}
        id={isHighlighted ? 'selectedOption' : ''}
        role="option"
        aria-selected={isHighlighted ? 'true' : 'false'}
      >
        <StyledItemWrapper className={isHighlighted ? 'item-highlighted' : ''} data-track={dataTrack}>
          {highlightedText}
        </StyledItemWrapper>
      </MenuItem>
    );
  };

  render() {
    return <Autocomplete {...this.props} getItemValue={this.getItemValue} renderItem={this.renderItem} wrapperProps={{ id: 'internalWrapper' }} />;
  }
}

const menuStyle = {
  borderWidth: '1px',
  borderColor: '#ccc',
  borderStyle: 'solid',
  overflow: 'auto',
  maxHeight: '10rem',
  borderRadius: '7px',
  position: 'fixed',
  zIndex: '1000',
};

AutoComplete.defaultProps = {
  value: '',
  items: [],
  onChange() {},
  onSelect() {},
  menuStyle,
  inputProps: {},
};
AutoComplete.propTypes = {
  value: PropTypes.string,
  items: PropTypes.array,
  onChange: PropTypes.func,
  getItemValue: PropTypes.func,
  renderItem: PropTypes.func,
  onSelect: PropTypes.func,
  menuStyle: PropTypes.object,
  wrapperStyle: PropTypes.object,
  inputProps: PropTypes.object,
  success: PropTypes.any,
  typedValue: PropTypes.any,
  showLoader: PropTypes.any,
  loopQualApp: PropTypes.any,
};

export default AutoComplete;
